import './AddUserInfo.css';
import updateUserData from '../../../assets/functions/updateUserData'
import React, {useState} from "react";

function AddPillar(props) {

    const [pillarTitle, setPillarTitle] = useState("");
    const [glowPercent, setGlowPercent] = useState(0);

    const handleTitleChange = (event) => {
        setPillarTitle(event.target.value);
      };

      const handleGlowChange = (event) => {
        setGlowPercent(event.target.value);
      };

      function resetAddPillar() {
        setPillarTitle("")
        setGlowPercent(0)
      }


    function addPillar() {
        if (props.pushChanges) {
            updateUserData("addPillar", {
                "title": pillarTitle,
                "glowPercent": glowPercent,}, 
                props.userProfile, 
                props.setUserProfile, 
                resetAddPillar)
        } else {
            let pillars = [...props.pillars]
            pillars.push({
                "title": pillarTitle,
                "glowPercent": glowPercent,})
            props.setPillars(pillars)
            resetAddPillar()
        }

    }

    return (
        <div className="addUserInfo">
            <div className="projectRow">
                <div >
                    <p className="addProjectTextHeader">pillar title</p>
                    <textarea
                    className="addUserInfoInputDiv"
                    type="text"
                    id="projectTitle"
                    value={pillarTitle}
                    onChange={handleTitleChange}
                    name="projectTitle"
                    spellCheck="false"
                    />
                </div>
                <div>
                    <p className="addProjectTextHeader">glow percentage</p>
                    <input
                    className="addUserInfoNumberDiv"
                    type="number"
                    id="glowPercent"
                    value={glowPercent}
                    onChange={handleGlowChange}
                    name="glowPercent"
                    min="0" max="100"
                    />
                </div>
            </div>
            <p onClick={()=> addPillar()} className="addUserInfoButton"> add pillar</p>
        </div>
    )
}

export default AddPillar;